import React, { useState, useEffect } from 'react';
import './ShippingMethod.css';
import { MONTHS, WEEKDAYS_FULL } from '../../../constants/DateConstants';
import { NewReleasesRounded } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import DateCell from './DateCell';
import { useTranslation } from 'react-i18next';

const DatePicker = (props) => {
  const sameDayPremium = useSelector(state => state.frontConfigReducer.same_day_delivery_fee)
  const calendarWeekEndDay = useSelector(state => state.frontConfigReducer.calendar_week_end_day)
  const cart = useSelector(state => state.cartReducer);
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const defaultStartDate = props.defaultDateInfo !== '' ? new Date(props.defaultDateInfo.year, props.defaultDateInfo.month, props.defaultDateInfo.date) : new Date();
  const defaultSelectedDate = props.defaultDate !== null ? props.defaultDate : '';
  const [weekData, setWeekData] = useState(populateWeekData(defaultStartDate));
  const [selectedDate, setSelectedDate] = useState(""); //useSelector(state => state.cartReducer.delivery.date);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // if (cart.delivery?.date !== "" && selectedDate) {
    //   const currentSelection = new Date(selectedDate);
    //   const deliveryDateInfo = getDateInfo(currentSelection);

    //   props.onDateSelect(deliveryDateInfo);
    //   props.setDateInfo(deliveryDateInfo);
    // } else {
    // props.onDateSelect(weekData[0]);
    // props.setDateInfo(weekData[0]);

  }, []);

  useEffect(() => {

  }, [selectedDate])

  useEffect(() => {

  }, [weekData])

  useEffect(() => {
    let startDate = new Date(weekData[0].year, weekData[0].month, weekData[0].date)
    checkForAvailabilities(populateWeekData(startDate))
    // checkForAvailabilities(weekData);

  }, [props.selectedOption])

  return (
    <div className="DatePicker">
      {/* <div className="DatePickerNavBtns">
        <button onClick={showPreviousWeek} style={{ color: mainColor }} className={"WeekNavBtn " + (weekData[0].isToday ? "WeekNavBtnDisabled" : "")}>{`< ${t('Previous week')}`}</button>
        <button onClick={showNextWeek} style={{ color: mainColor }} className="WeekNavBtn">{`${t('Next week')} >`}</button>
      </div> */}
      <div className="DatesContainer">
        {renderDates()}
      </div>
    </div>
  )

  function getDateInfo(DateObj) {
    let dateToday = new Date();
    const newMonth = DateObj.getMonth();
    const newMonthText = (newMonth + 1 < 10) ? '0' + (newMonth + 1).toString() : (newMonth + 1).toString();
    const newDay = DateObj.getDay();
    const newYear = DateObj.getFullYear();
    const newDate = DateObj.getDate();
    const newDateText = (newDate < 10) ? '0' + (newDate).toString() : (newDate).toString();
    const isToday = (newDate === dateToday.getDate() && newMonth === dateToday.getMonth() && newYear === dateToday.getFullYear());

    let dateInfo = {
      isToday: isToday,
      dayTextClipped: WEEKDAYS_FULL[newDay].substring(0, 3).toUpperCase(),
      dayTextFull: WEEKDAYS_FULL[newDay],
      day: newDay,
      date: newDate,
      dateApiStr: newDateText,
      monthText: MONTHS[newMonth],
      month: newMonth,
      monthApiStr: newMonthText,
      year: newYear,
      apiDate: `${newYear}-${newMonthText}-${newDateText}`,
    };

    return dateInfo;
  };

  function populateWeekData(startDate = new Date()) {
    let calendar_week_end_day = Number(calendarWeekEndDay)
    let week = [];
    let newStartDate = new Date(startDate); // Clone to prevent mutation

    const startDay = newStartDate.getDay(); // Get today's day index (0 = Sunday, 6 = Saturday)

    // Calculate how many days to display until calendar_week_end_day
    let totalDays;
    if (calendar_week_end_day >= startDay) {
        totalDays = calendar_week_end_day - startDay + 1; // Days within the same week
    } else {
        totalDays = (7 - startDay) + (calendar_week_end_day + 1); // Wrap around to next week
    }

    // If today is the end day (e.g., Monday and calendar_week_end_day is Monday), show the next week's range
    if (startDay === calendar_week_end_day) {
        newStartDate = new Date(newStartDate.setDate(newStartDate.getDate() + 1)); // Move start date to Monday
        totalDays = 7; 
    }

    console.log("calendarWeekEndDay---", calendar_week_end_day, totalDays)
    // Generate the week data
    for (let i = 0; i < totalDays; i++) {
        let newDateObj = new Date(newStartDate);
        newDateObj.setDate(newStartDate.getDate() + i);
        const dateInfo = getDateInfo(newDateObj); // Assuming this formats the date correctly
        week.push(dateInfo);
    }

    return week;
  }





  function checkForAvailabilities(week) {
    let newWeekData = week.slice();
    let selectedOptionLength = props.selectedOption.length;
    if (selectedOptionLength > 0) {
      newWeekData = newWeekData.map((dayData) => {
        for (let i = 0; i < selectedOptionLength; i++) {
          let option = props.selectedOption[i];
          dayData.dayIsBlocked = dayData.isToday && option.accept_same_day_delivery !== true ? true : false;
          let filteredByDay = option.availabilities.filter(days => days.code === dayData.dayTextFull);
          if (filteredByDay[0]) {
            let filteredByDate = filteredByDay[0].dates.filter(dateData => dateData.date === dayData.apiDate);
            dayData.noAvailabilities = (filteredByDate[0] && filteredByDate[0].is_closed !== true) ? false : true;
            dayData.noAvailabilities = dayData.isToday && option.accept_same_day_delivery !== true ? true : dayData.noAvailabilities
          } else {
            dayData.noAvailabilities = dayData.noAvailabilities !== false ? true : false;
            dayData.noAvailabilities = dayData.isToday && option.accept_same_day_delivery !== true ? true : dayData.noAvailabilities
          }
        }
        return dayData;
      })
      setWeekData(newWeekData);
    }
  }




  function showNextWeek() {
    let endOfWeekData = weekData[6];
    let nextWeekStartDate = endOfWeekData.date + 1;
    let nextWeekDate = new Date(endOfWeekData.year, endOfWeekData.month, nextWeekStartDate);

    // setWeekData(populateWeekData(nextWeekDate));
    checkForAvailabilities(populateWeekData(nextWeekDate))
  }

  function showPreviousWeek() {
    if (!weekData[0].isToday) {
      let startOfWeekData = weekData[0];
      let previousWeekStartDate = startOfWeekData.date - 7;
      let previousWeekDate = new Date(startOfWeekData.year, startOfWeekData.month, previousWeekStartDate);

      // setWeekData(populateWeekData(previousWeekDate));
      checkForAvailabilities(populateWeekData(previousWeekDate))
    }
  }

  function renderDates() {
    return weekData.map((dateInfo, i) => {
      const weekdayHeader = (dateInfo.isToday ? "TODAY" : dateInfo.dayTextClipped);
      return (
        <DateCell key={dateInfo.apiDate} isSelected={(selectedDate === dateInfo.apiDate)} dateInfo={dateInfo} index={i} onSelect={selectDate} weekdayHeader={weekdayHeader} />
      )
    });
  }

  function selectDate(date, dateInfo) {
    if (selectedDate !== dateInfo.apiDate) {
      setSelectedDate(date);
      props.onDateSelect(dateInfo);
    }
  }
}

export default DatePicker;